import { Controller } from "@hotwired/stimulus"

// Handles add-customer modal inside invoice form.
export default class extends Controller {
  static targets = ["modal", "form", "errorBox", "submitLabel", "submitSpinner"]

  open(event) {
    event.preventDefault()
    this.modalTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
  }

  close(event) {
    if (event) event.preventDefault()
    this.modalTarget.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
  }

  closeOnBackdrop(event) {
    if (event.target === this.modalTarget) this.close()
  }

  async submit(event) {
    event.preventDefault()
    this.clearErrors()
    this.toggleSubmitting(true)

    try {
      const res = await fetch(this.formTarget.action, {
        method: "POST",
        headers: {
          "Accept": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        },
        body: new FormData(this.formTarget)
      })

      const data = await res.json()

      if (!res.ok) {
        this.showErrors(data.errors || ["Unable to create customer."])
        return
      }

      window.dispatchEvent(new CustomEvent("invoice:customer-created", { detail: data.customer }))
      this.formTarget.reset()
      this.close()
    } catch (_error) {
      this.showErrors(["Network error. Please try again."])
    } finally {
      this.toggleSubmitting(false)
    }
  }

  toggleSubmitting(isSubmitting) {
    if (this.hasSubmitLabelTarget) this.submitLabelTarget.classList.toggle("hidden", isSubmitting)
    if (this.hasSubmitSpinnerTarget) {
      this.submitSpinnerTarget.classList.toggle("hidden", !isSubmitting)
      this.submitSpinnerTarget.classList.toggle("inline-flex", isSubmitting)
    }
  }

  showErrors(errors) {
    if (!this.hasErrorBoxTarget) return
    this.errorBoxTarget.innerHTML = errors.map((msg) => `<p>${msg}</p>`).join("")
    this.errorBoxTarget.classList.remove("hidden")
  }

  clearErrors() {
    if (!this.hasErrorBoxTarget) return
    this.errorBoxTarget.classList.add("hidden")
    this.errorBoxTarget.innerHTML = ""
  }
}
